const eventsModule = {
    actions: {
        setType: 'events/actions/setType',
        initFilter: 'events/actions/initFilter',
        resetPagination: 'events/actions/resetPagination',
        setSpot: 'events/actions/setSpot',
        spot: {
            submit: 'spot/actions/submit',
            loadInfo: 'spot/actions/loadInfo',
        },
        spots:{
            load: 'spots/actions/load',
            remove: 'spots/actions/remove'
        },
        events: {
            submit: 'events/actions/events/submit',
            remove: 'events/actions/events/remove',
            cleanUp: 'events/actions/events/cleanUp',
            updateInvitedMembers: 'clubs/actions/clubs/updateInvitedMembers',
            update: 'events/actions/events/update',
            load: 'events/actions/events/load',
            loadMy: 'events/actions/events/loadMy',
            loadMoreByDate: 'events/actions/events/loadMoreByDate',
            loadInfo: 'events/actions/events/loadInfo',
            report: 'events/actions/events/report',
            like: 'events/actions/events/like',
            loadMembers : 'events/actions/events/loadMembers',
            updateMembers: 'events/actions/events/updateMembers'
        },
        membership: {
            set: 'events/actions/membership/set',
            setMy: 'events/actions/membership/setMy',
            add: 'events/actions/membership/add',
            addMy: 'events/actions/membership/addMy',
            remove: 'events/actions/membership/remove',
            removeMy: 'events/actions/membership/removeMy',

            request: 'events/actions/membership/request',
            update: 'events/actions/membership/update',

            subscribe: 'events/actions/membership/subscribe',
            unsubscribe: 'events/actions/membership/unsubscribe',
            unsubscribeFromAll: 'events/actions/membership/unsubscribeFromAll',
        },
        setBang: 'events/actions/setBang',
        setEvent: 'events/actions/setEvent',
        getStickyEvents: 'events/actions/getStickyEvents',
    },
    mutations: {
        setType: 'events/mutations/setType',
        resetPagination: 'events/mutations/resetPagination',
        setDateLoading: 'events/mutations/setDateLoading',
        setTransitionEnabled : 'events/mutations/setTransitionEnabled',
        events: {
            update: 'events/mutations/events/update',
            addDates: 'events/mutations/events/addDates',
            set: 'events/mutations/events/set',
            remove: 'events/mutations/events/remove',
            insert: 'events/mutations/events/insert',
            setPageNum: 'events/mutations/events/setPageNum',
            setPageMembersNum : 'events/mutations/events/setPageMembersNum',
        },
        spots:{
            clearSpots: 'spots/mutations/clearSpots',
            addSpots: 'spots/mutations/addSpots',
            removeSpot: 'spots/mutations/removeSpot',
            setSpotPageNum: 'spots/mutations/setSpotPageNum',
            updateSpot: 'spots/mutations/updateSpot'
        },
        membership: {
            add: 'events/mutations/membership/add',
            remove: 'events/mutations/membership/remove',
            addMy: 'events/mutations/membership/addMy',
            removeMy: 'events/mutations/membership/removeMy',
        },
        setSpot: 'events/mutations/setSpot',
        setBang: 'events/mutations/setBang',
        setEvent: 'events/mutations/setEvent',
        setLikes: 'events/mutations/setLikes',
        setStickyEvents: 'events/mutations/setStickyEvents',
    },
    getters: {
        type: 'events/getters/type',
        eventDates: 'events/getters/eventDates',
        eventIdsByDate: 'events/getters/eventIdsByDate',
        membershipRequests: 'events/getters/membershipRequests',
        hasMembershipRequests: 'events/getters/hasMembershipRequests',
        bang: 'events/getters/bang',
        event: 'events/getters/event',
        stickyEvents: 'events/getters/stickyEvents',
        eventTransitionEnabled: 'events/getters/eventTransitionEnabled',
        membershipExists: 'events/getters/membershipExists',
        spots : 'spots/getters',
        spot: 'events/getters/spot'
    }
}

export default eventsModule
